<template>
	<QrcodeNavListShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QrcodeNavListShell from '../shared/QrcodeNavListShell.vue';
	import { qrcodeNavMixin } from '../shared/mixin.js';

	export default {
		name: 'GBlockQrcodeNavList',
		components: { QrcodeNavListShell },
		mixins: [qrcodeNavMixin],
	};
</script>
